import styles from './Chip.module.css'

export interface ChipProps {
  value: number
  onClick?: () => void
  disabled?: boolean
  selected?: boolean
  size?: 'sm' | 'lg'
}

/* Casino chip that sets a bet amount. */
export function Chip({ value, onClick, disabled, selected, size = 'sm' }: ChipProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      aria-pressed={selected}
      className={[styles.chip, styles[size], selected && styles.selected].filter(Boolean).join(' ')}
    >
      ${value}
    </button>
  )
}
